<template>
<div>
  <el-result style="margin-top: 50px" icon="error" title="缺少必要参数" subTitle="">
    <template slot="extra">
    </template>
  </el-result>

</div>
</template>

<script>
export default {
name: "noAuth"
}
</script>

<style scoped>

</style>